import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useApproveKeyChangeMutation } from "store/slices/apis/keyChangeTrackerSlice";

export default function ApproveChangeTrackerComponent(props) {
  const { open, cancel, rowData, keys, refetch } = props;
  const theme = useTheme();
  const [approveKeyChange] = useApproveKeyChangeMutation();
  const dispatch = useDispatch();

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleApprove = async () => {
    if (keys === "change") {
      try {
        const response = await approveKeyChange({
          id: rowData?.change_id,
        });

        if (response?.data?.status === "success") {
          openNotification(
            response?.data?.message || "Change Tracker approved successfully",
            "success"
          );
          cancel();
          refetch();
        } else {
          openNotification("Error in approve change tracker");
        }
      } catch (error) {
        openNotification(error?.error, "error");
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Approve
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
          >
            Are you sure you want to Approve this change tracker? This action is permanent.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={cancel}
            sx={{
              color: `${theme?.customSettings?.themeColor}`,
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
              border: `1px solid ${theme?.customSettings?.themeColor}`,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleApprove}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
